import { OPEN_THIRD_PARTY_WIDGET } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
import { flatten } from './openCallingWidget';
export default function openThirdPartyWidget(options) {
  return callingAPIMethodWithQueue(OPEN_THIRD_PARTY_WIDGET, options, flatten);
}